<div class="cart-container">
  <button
    type="button"
    mat-icon-button
    color="primary"
    class="mat-icon-button-small"
    matBadgeSize="small"
    data-qa="chat-button"
    [attr.aria-label]="'Chats' | translate"
    [attr.data-qa-unseen]="unseenMessagesCount()"
    [matBadge]="unseenMessagesCount()"
    [matBadgeHidden]="!unseenMessagesCount()"
    [disableRipple]="true"
    (click)="onOpenConversationsList()"
  >
    <mat-icon svgIcon="ring" color="white" />
  </button>
</div>
